import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function l(t, n) {
  var r = "auto",
    u = Array.from(t.children);
  return u.length === 0 ? r : u.map(function (e) {
    return getComputedStyle(e)[n];
  }).filter(function (e) {
    return !Number.isNaN(+e);
  }).reduce(function (e, i) {
    return e > i ? e : i;
  }, "0");
}
function c(t) {
  if (!t) return [];
  if (t.children.length === 0) return [t];
  var n = [];
  for (var r = 0; r < t.children.length; r += 1) {
    var u = c(t.children[r]);
    u && n.push.apply(n, _toConsumableArray(u));
  }
  return n.push(t), n;
}
export { l as c, c as u };